import { render } from "./EmptyState.vue?vue&type=template&id=51437279&scoped=true&ts=true"
import script from "./EmptyState.vue?vue&type=script&lang=ts"
export * from "./EmptyState.vue?vue&type=script&lang=ts"

import "./EmptyState.vue?vue&type=style&index=0&id=51437279&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51437279"]])

export default __exports__